/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Templates_EmptyInputs */

const en_us2_coaching_templates_empty = /** @type {(inputs: Coaching_Templates_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No templates yet.`)
};

const pt_br2_coaching_templates_empty = /** @type {(inputs: Coaching_Templates_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum modelo ainda.`)
};

const pt_pt2_coaching_templates_empty = /** @type {(inputs: Coaching_Templates_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum modelo ainda.`)
};

/** @type {(inputs: Coaching_Templates_EmptyInputs) => LocalizedString} */
const es_419_coaching_templates_empty = en_us2_coaching_templates_empty;

/** @type {(inputs: Coaching_Templates_EmptyInputs) => LocalizedString} */
const fr_fr2_coaching_templates_empty = en_us2_coaching_templates_empty;

/** @type {(inputs: Coaching_Templates_EmptyInputs) => LocalizedString} */
const de_de2_coaching_templates_empty = en_us2_coaching_templates_empty;

/** @type {(inputs: Coaching_Templates_EmptyInputs) => LocalizedString} */
const it_it2_coaching_templates_empty = en_us2_coaching_templates_empty;

/**
* | output |
* | --- |
* | "No templates yet." |
*
* @param {Coaching_Templates_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_templates_empty = /** @type {((inputs?: Coaching_Templates_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Templates_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_templates_empty(inputs)
	if (locale === "es-419") return es_419_coaching_templates_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_templates_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_templates_empty(inputs)
	if (locale === "de-DE") return de_de2_coaching_templates_empty(inputs)
	if (locale === "it-IT") return it_it2_coaching_templates_empty(inputs)
	return en_us2_coaching_templates_empty(inputs)
});
export { coaching_templates_empty as "coaching.templates_empty" }